import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useToast } from "./common/ToastProvider";

const signaturePadStyles = `
  @media (max-width: 600px) {
    .signature-pad-container {
      max-height: 80vh;
      overflow-y: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }
`;

export default function SignaturePadComponent({ onSave }) {
  const padRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);

  const toast = useToast();

  const clear = () => {
    if (!padRef.current) return;
    padRef.current.clear();
  };

  const save = async () => {
    if (!padRef.current) return;
    if (isSaving) return;

    if (padRef.current.isEmpty()) {
      toast.error("Please draw signature");
      return;
    }

    // Use raw canvas instead of getTrimmedCanvas()
    const canvas = padRef.current.getCanvas();
    const base64 = canvas.toDataURL("image/png");

    try {
      setIsSaving(true);
      await Promise.resolve(onSave(base64));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <style>{signaturePadStyles}</style>
      <div
        className="signature-pad-container"
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 20,
          boxShadow: "0 8px 25px rgba(0,0,0,0.12)",
          maxWidth: 520,
        }}
      >
        <h3 style={{ marginBottom: 10 }}>Draw Signature</h3>

        <div
          style={{
            border: "2px dashed var(--primary)",
            borderRadius: 10,
            overflow: "hidden",
            marginBottom: 15,
          }}
        >
          <SignatureCanvas
            ref={padRef}
            penColor="black"
            canvasProps={{
              width: 480,
              height: 200,
              style: {
                background: "#f9fafb",
                display: "block",
              },
            }}
          />
        </div>

        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={save}
            className="btn btn-primary"
            style={{ flex: 1 }}
            disabled={isSaving}
          >
            {isSaving ? "Applying..." : "Apply Signature"}
          </button>

          <button
            onClick={clear}
            className="btn btn-light"
            style={{ flex: 1 }}
            disabled={isSaving}
          >
            Clear
          </button>
        </div>
      </div>
    </>
  );
}
